import { gql } from '@apollo/client';

// NCP-5260: drop ApplicationGroup members whose Phase 3 survey was never
// completed. Adding a LOB on the quote page pushes its Application into the
// group and redirects to that survey; abandoning it leaves the group claiming a
// coverage with no answers to quote from, which fails the whole quote page.
// Called on quote-page arrival — the one place "every member is completed" is a
// real invariant. Never call it from Phase 2.
export default gql`
  mutation pruneIncompleteLobs($applicationGroupId: ObjectID!) {
    pruneIncompleteLobs(applicationGroupId: $applicationGroupId) {
      applicationGroupId
      removedApplicationIds
      removedLobTypes
    }
  }
`;
